<template>
	<div>
		<TextEditor :entity="form" label="Navn" alias="5d139c4a0512d063ecf457fe" :validate="true" scope="productspec"></TextEditor>

		<!-- <UserPicker :entity="form" label="Ejer" alias="5ce68f0ad6c2910bb09c58a6" :values="$users" :validate="true" scope="productspec"></UserPicker> -->
	</div>
</template>

<script>
import UserPicker from "../../_ui/editors/user";
import TextEditor from "../../_ui/editors/text";

export default {
	data: () => ({
		form: {}
	}),
	components: { UserPicker, TextEditor },
	computed: {},
	watch: {},
	props: [],
	methods: {
		ok() {
			this.$validator.validate("productspec.*").then(valid => {
				if (valid) {
					this.$http.put("/api/module/products/productspecs", this.form).then(x => {
						this.$emit("close");

						this.$router.push("/products/productspecs/" + x.data);
					});
				}
			})
		},
		cancel() {
			this.$emit("close");
		}
	},
	created() {},
	mounted() {},
};
</script>